// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"04657ada","513":"0840e534","703":"8cf5bc7d","787":"7a870dff"}[chunkId] + ".chunk.js";
};